/**
 * Set the number of todos in the state indicator.
 *
 * Only work in state indicators with state `:todo`,
 * crashes on other state indicators.
 *
 * @param {HTMLElement} el - The state indicator
 * @param {Number} count - The number to use
 */
export function setTodoCount(el, count) {
  el.querySelector(".state-indicator__count").textContent = count;
}
